import "@fortawesome/fontawesome-free/css/all.css";
import "primevue/resources/themes/bootstrap4-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "@/scss/style.scss";
import "@/assets/js/qrcode.script";
import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives";
import globalFilters from "./globalFilters";
import { VueConstructor } from "vue";

import Modal from "@/plugins/modal/modal";
import Scrollspy from "vue2-scrollspy";
import VueToastr from "vue-toastr";
import VueCurrencyInput from "vue-currency-input";

import debounce from "@/utils/debounce";
// import html2canvas from 'html2canvas';

const queryList = window.matchMedia("(max-width: 991px)");

export default {
  install(Vue: VueConstructor) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
    Vue.use(globalFilters);
    Vue.use(Modal);
    Vue.use(Scrollspy);
    Vue.use(VueToastr, {
      defaultTimeout: 2000,
      defaultProgressBar: false,
      defaultClassNames: ["custom-toastr"]
    });
    Vue.use(VueCurrencyInput);
    Vue.prototype.$debounce = debounce;
    Vue.prototype.$isMobile = window.matchMedia("(max-width: 991px)").matches;
    // Vue.prototype.$html2canvas = html2canvas;
  }
};
